import { Box, Stack, VStack } from "@chakra-ui/react";
import React from "react";
import BroadCast from "./components/BroadCast";
import RecordedSessions from "./components/RecordedSessions";
import LiveChat from "./components/LiveChat";
import FavoriteSessions from "./components/FavoriteSessions";
import Header from "../../components/layouts/Header/Header";
import HeaderGap from "../../components/layouts/Header/HeaderGap";
import "./liveCast.component.css";

const LiveCast = () => {
  return (
    <div>
      <Header />
      <HeaderGap />
      <VStack
        bg={"rgba(245, 245, 255, 1)"}
        w="100%"
        h="100%"
        paddingBottom="25px"
      >
        <Box w="80%" mx="auto" className="live-cast">
          {/* desktop-version */}
          <Stack
            flexDir="row"
            gap={"0"}
            justifyContent="flex-start"
            alignItems="flex-start"
            w="100%"
            className="desktop-version"
          >
            <Box w="70%" h="100%">
              <BroadCast />
              <RecordedSessions />
            </Box>
            <Box w="30%" h="100%">
              <LiveChat />
              <FavoriteSessions />
            </Box>
          </Stack>
          {/* mobile-version */}
          <Stack
            gap={"0"}
            justifyContent="flex-start"
            alignItems="flex-start"
            w="100%"
            className="mobile-version"
          >
            <Box w="100%" h="100%">
              <BroadCast />
              <LiveChat />
              
            </Box>
            <Box w="100%" h="100%">
             <RecordedSessions />
              <FavoriteSessions />
            </Box>
          </Stack>
        </Box>
      </VStack>
    </div>
  );
};

export default LiveCast;
